import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef, Renderer2, HostListener } from '@angular/core';
import { ExhibitService, PosterService } from 'src/app/_services/generatedServices';
import { Subscription, of } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhibitDesignerViewModel, UserAuthenticationViewModel, PosterViewModel, ActivePosterUserViewModel } from 'src/app/_models/generatedModels';
import { ToasterService } from 'src/app/_services/toaster.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { DefaultReconnectPolicy } from 'src/app/_helpers/signalR-retry-policy';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { OpentokService } from 'src/app/_services/opentok.service';
import { ChatViewModel, SelectedDevice } from 'src/app/_models/models';
import { CameraTestModalComponent } from '../../events/live/camera-test/camera-test-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { delay } from 'rxjs/operators';
const initLayoutContainer = require('opentok-layout-js');
declare var zE: any;

@Component({
  selector: 'bxl-poster-dashboard',
  templateUrl: 'poster-dashboard.component.html',
})
export class PosterDashboardComponent implements OnInit, OnDestroy {
  initialized = false;
  showVisitors = false;
  showAnalytics = false;
  session: OT.Session;
  userCount: number;
  randomUserIds: number[];
  public user: UserAuthenticationViewModel;
  posterId: number;
  public selectedDevice: SelectedDevice;
  public connection: HubConnection;
  public isFullScreen: boolean;
  publisher: OT.Publisher;
  public showChat = true;

  screenPublisher: OT.Publisher;
  public publishing: boolean;
  public screenPublishing: boolean;
  public publishingAudio = true;
  public publishingVideo = true;
  public streamCount = 0;
  public chatMessage: string;
  public messages: ChatViewModel[] = new Array();
  toggled: boolean = false;
  showPicker: boolean = false;
  preview: boolean = false;
  poster: PosterViewModel;

  private routeSubscription: Subscription;
  @ViewChild('messageContainer') private messageContainer: ElementRef;
  @ViewChild('webRTCLayoutContainer') webRTCLayoutContainer: ElementRef;
  @ViewChild('fullScreen') fullScreen: ElementRef;
  @ViewChild('chatbox') private chatbox: ElementRef;
  layout: any;

  constructor(private posterService: PosterService, private modalService: NgbModal, private renderer: Renderer2, private opentokService: OpentokService, private ref: ChangeDetectorRef, private auth: AuthenticationService, private route: ActivatedRoute, private router: Router, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.user = this.auth.getUser();
    console.log(this.user);
    document.body.style.backgroundColor = '#fff';
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide');
    });

    this.preview = this.route.snapshot.data.preview;

    this.routeSubscription = this.route.paramMap.subscribe((param) => {
      this.posterId = parseInt(param.get('posterId'));

      this.posterService.getPosterById(this.posterId).subscribe((poster) => {
        this.poster = poster;
        this.InitSignalR();
        this.InitOpenTok();

        // this.populateDropdowns();
      });
    });
  }

  checkAndDisplayPreviewError(): boolean {
    if (this.preview) {
      this.toaster.messageDialog('You are in preview mode, and this function is not available.', 'Preview Mode').subscribe();
      return this.preview;
    }
    return this.preview;
  }

  InitSignalR(): any {
    this.connection = new HubConnectionBuilder()
      .withUrl('/posterHub', { accessTokenFactory: () => this.auth.getToken() })
      .withAutomaticReconnect(new DefaultReconnectPolicy())
      .build();

    this.connection.start().then(() => {
      this.connection.invoke('connectToPoster', this.posterId);
    });

    this.connection.on('postChat', (id: number, name: string, message: string, userId: number, posterId: number) => {
      console.log('chat received' + this.posterId);
      if (this.posterId === posterId) {
        this.messages.push(new ChatViewModel(id, name, message, userId));
        this.scrollToBottom();
      }
    });

    this.initialized = true;
  }

  scrollToBottom(): void {
    of(null)
      .pipe(delay(100))
      .subscribe((result) => {
        try {
          this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
        } catch (err) {}
      });
  }

  techSupportClicked() {
    zE('webWidget', 'show');
    zE('webWidget', 'open');
  }

  InitOpenTok() {
    this.ref.detectChanges();
    this.layout = initLayoutContainer(this.webRTCLayoutContainer.nativeElement).layout;
    let layout = this.layout;

    this.opentokService
      .initSessionForPosters(this.posterId)
      .then((session: OT.Session) => {
        this.session = session;
        this.session.on('streamCreated', (event) => {
          console.log(event.stream.name);
          console.log(event.stream.connection.data);
          this.streamCount++;

          let subscription = this.session.subscribe(event.stream, 'webRTCLayoutContainer', {
            insertMode: 'append',
            style: { nameDisplayMode: 'off' },
          });

          subscription.element.addEventListener('dblclick', function () {
            if (subscription.element.classList.contains('OT_big')) {
              subscription.element.classList.remove('OT_big');
            } else {
              subscription.element.classList.add('OT_big');
            }
            layout();
          });
          layout();
          this.ref.detectChanges();
        });
        this.session.on('streamDestroyed', (event) => {
          this.streamCount--;
          session.getSubscribersForStream(event.stream).forEach((subscriber) => {
            subscriber.element.classList.remove('ot-layout');
            setTimeout(() => {
              layout();
            }, 200);
          });
        });
      })
      .then(() => this.opentokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }

  showDeviceSettings() {
    const modalRef = this.modalService.open(CameraTestModalComponent, { size: 'lg', backdrop: 'static', ariaLabelledBy: 'modal-basic-title' });
    if (this.selectedDevice) {
      console.log(this.selectedDevice);
      modalRef.componentInstance.selectedDevice = this.selectedDevice;
    }
    modalRef.result.then(
      (result) => {
        this.selectedDevice = result;

        if (this.publisher) {
          this.publisher.destroy();
          if (this.publishing) {
            this.activateCamera();
          }
        }
      },
      (reason) => {}
    );
    return;
  }

  activateCamera() {
    if (this.checkAndDisplayPreviewError()) {
      return;
    }

    this.ref.detectChanges();

    const OT = this.opentokService.getOT();
    const el = this.renderer.createElement('div');

    if (this.selectedDevice) {
      this.publisher = OT.initPublisher(el, { publishAudio: this.publishingAudio, publishVideo: this.publishingVideo, resolution: '1280x720', name: 'billbob', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'off', archiveStatusDisplayMode: 'off', buttonDisplayMode: 'off' }, audioSource: this.selectedDevice.audioDeviceId, videoSource: this.selectedDevice.videoDeviceId });
    } else {
      this.publisher = OT.initPublisher(el, { publishAudio: this.publishingAudio, publishVideo: this.publishingVideo, resolution: '1280x720', name: 'billbob', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'off', archiveStatusDisplayMode: 'off', buttonDisplayMode: 'off' } });
    }

    let layout = this.layout;

    el.addEventListener('dblclick', function () {
      if (el.classList.contains('OT_big')) {
        el.classList.remove('OT_big');
      } else {
        el.classList.add('OT_big');
      }
      layout();
    });

    this.renderer.appendChild(this.webRTCLayoutContainer.nativeElement, el);
    layout();

    if (this.session) {
      if (this.session['isConnected']()) {
        this.publish();
      }
      this.session.on('sessionConnected', () => this.publish());
    }
  }

  publish() {
    this.session.publish(this.publisher, (err) => {
      if (err) {
        alert(err.message);
      } else {
        this.publishing = true;
        this.layout();
        this.ref.detectChanges();
        this.layout();
      }
    });
  }

  toggleVideo() {
    this.publishingVideo = !this.publishingVideo;
    this.publisher.publishVideo(this.publishingVideo);
  }

  toggleAudio() {
    this.publishingAudio = !this.publishingAudio;
    this.publisher.publishAudio(this.publishingAudio);
  }

  unpublish() {
    this.publishing = false;
    this.ref.detectChanges();
    this.session.unpublish(this.publisher);
    this.layout();
  }

  usersUpdated(event: ActivePosterUserViewModel[]) {
    this.userCount = event.filter((x) => x.connected).length;
    this.randomUserIds = event
      .filter((x) => x.connected)
      .map((x) => x.id)
      .slice(0, 6);
  }

  exitPage() {
    if (this.preview) {
      this.router.navigate(['/account/posters']);
      return;
    }

    this.toaster.confirmDialog('Are you sure you want to leave this poster?', 'Exit?', 'Yes, Exit', 'Cancel').subscribe((result) => {
      if (result) {
        this.router.navigate(['/account/posters']);
      }
    });
  }

  public sendMessage() {
    if (this.checkAndDisplayPreviewError()) {
      return;
    }

    this.connection.invoke('postChat', this.user.firstName + ' ' + this.user.lastName, this.chatMessage, this.user.id, this.posterId);
    this.chatMessage = null;
  }

  shareScreen() {
    const OT = this.opentokService.getOT();
    const el = this.renderer.createElement('div');
    this.screenPublisher = OT.initPublisher(el, { videoSource: 'screen', width: '100%', insertDefaultUI: true });

    let layout = this.layout;

    el.classList.add('OT_big');

    el.addEventListener('dblclick', function () {
      if (el.classList.contains('OT_big')) {
        el.classList.remove('OT_big');
      } else {
        el.classList.add('OT_big');
      }
      layout();
    });

    this.renderer.appendChild(this.webRTCLayoutContainer.nativeElement, el);
    layout();

    if (this.session) {
      if (this.session['isConnected']()) {
        this.publishScreen();
      }
      this.session.on('sessionConnected', () => this.publishScreen());
    }
  }

  publishScreen() {
    this.session.publish(this.screenPublisher, (err) => {
      if (err) {
        alert(err.message);
        this.layout();
      } else {
        this.screenPublishing = true;
        this.layout();
        this.ref.detectChanges();
        this.layout();
      }
    });
  }

  stopScreenSharing() {
    this.session.unpublish(this.screenPublisher);
    this.screenPublishing = false;
    this.layout();
  }

  handleSelection(char) {
    if (this.chatMessage == null) {
      this.chatMessage = '';
    }

    this.chatMessage = this.chatMessage + char;
    this.toggled = false;
    this.chatbox.nativeElement.focus();
  }

  fullscreen() {
    this.ref.detectChanges();
    let elem = this.fullScreen.nativeElement;
    let doc = <any>document;
    if (!this.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      setTimeout(() => {
        this.layout();
        this.isFullScreen = true;
      }, 500);
    } else {
      if (document.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        /* Firefox */
        doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        /* IE/Edge */
        doc.msExitFullscreen();
      }
      setTimeout(() => {
        this.isFullScreen = false;
        this.layout();
      }, 500);
    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  exit(ev) {
    if (this.isFullScreen) {
      of(null)
        .pipe(delay(3000))
        .subscribe((result) => {
          this.isFullScreen = false;
          console.log('exiting');
          this.layout();
        });
    }
  }

  @HostListener('window:resize', ['$event'])
  resize(evt) {
    this.layout();
  }

  ngOnDestroy(): void {
    document.body.style.backgroundColor = '#fff';

    this.routeSubscription.unsubscribe();

    if (this.connection) {
      this.connection.stop();
    }

    if (this.publisher) {
      this.publisher.destroy();
    }

    if (this.screenPublisher) {
      this.screenPublisher.destroy();
    }

    if (this.session) {
      this.session.off('streamCreated');
      this.session.off('streamDestroyed');
      this.session.disconnect();
    }
  }
}
